const faqs = [
    {
        question:"Is trip together safe to use?",
        reply:"Yes, safety is a priority for us. While we encourage connections and cost-sharing, we also provide guidelines and safety tips for users."
    },
    {
        question:"Who can use Trip Together?",
        reply:"Trip Together is open to anyone facing urgent travel needs or seeking to reduce travel costs."
    },
    {
        question:"How do I create an account on Trip Together?",
        reply:'Creating an account on Trip Together is easy. Simply visit our website and click on the "Log in or Register" button.'
    },
    {
        question:"How do I provide feedback or report an issue?",
        reply:'We value your feedback!you can reach out to our support team through the "Contact Us" section on our website.'
    },
]

export default faqs;